export enum ReadyStateFlag{
	LOADING = 'LOADING',
	READY = 'READY',
	ERROR = 'ERROR'
}
export interface ReadyState {
    state?: ReadyStateFlag|string;
    message?:string;
};